module.exports = __webpack_public_path__ + "img/cta_2.3ee82a7a.png";